export default {
      id: "command__key_suspend-usage",
      viewBox: "0 0 92.7 88.2",
      url: __webpack_public_path__ + "img/icons.svg#command__key_suspend",
      toString: function () {
        return this.url;
      }
    }